// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"93":"a4de2978","180":"c6f83dec","234":"a698a598","264":"ad553438","324":"d3f49bf0","359":"35249fdd","453":"0cf64050","723":"c4cfc488","933":"a55c0147","954":"03736760","980":"d6bf2a5f"}[chunkId] + ".chunk.js";
};